import {NgModule, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: false
})

export class HighlightSearchPipe implements PipeTransform {

    transform(value: any, {key, isHighlight = true, color = '', cssClass = 'bg-highlight'}): any {
        if (!key || !isHighlight) {
            return value;
        }
        if (key.substr(0, 1) == '"' && key.substr(-1) == '"') {
            key = key.substr(1, key.length - 2);
        } else {
            //
            key = key.replace(/ (?!$)/, "|").replace(" ", "");
        }
        let re = new RegExp(key, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
        let style = color ? `style="background-color: ${color}"` : '';
        return value.replace(re, `<mark ${style} class='${cssClass}'>$&</mark>`);
    }
}

@NgModule({
    declarations: [HighlightSearchPipe],
    exports: [HighlightSearchPipe]
})
export class HighlightSearchPipeModule {}
